import { isEmpty } from "lodash";
import { Reference } from "@services/api/reference/reference.types";
import { getName } from "../types/Name";
import { type ProductType, ProductTypeEnum } from "../types/Product";

export enum ReferenceType {
  QUERY_KEY_ALL = "referencesAll",
  CALENDAR_PERIOD = "CALENDAR-PERIOD",
  FACULTY_DESCRIPTION = "FACULTY_DESCRIPTION",
  QUALIFICATION_DESCRIPTION = "QUALIFICATION_DESCRIPTION",
  SPECIFICATION_DESCRIPTION = "SPECIFICATION_DESCRIPTION",
  STUDY_DESCRIPTION = "STUDY_DESCRIPTION",
  MODULEGROUP_DESCRIPTION = "MODULEGROUP_DESCRIPTION",
  MODULE_DESCRIPTION = "MODULE_DESCRIPTION",
  GROUP_TYPE = "GROUP_TYPE",
  METHOD_TYPE = "METHOD_TYPE",
  LINK = "LINK",
  PERIOD = "PERIOD",
  PHASE = "PHASE",
  SOFTWARE = "SOFTWARE",
  TIME_BLOCK = "TIME-BLOCK"
}

export const REFERENCE_TYPE_QUERY_KEY = "referenceTypes";

export function getReferenceDisplayName(
  externalId: string | undefined,
  references: Reference[],
  defaultValue?: string
) {
  if (isEmpty(externalId)) {
    return;
  }

  const reference = references.find((ref) => ref.externalId === externalId);
  let name;
  if (reference) {
    name = getName(reference);
  }
  return isEmpty(name) ? defaultValue || externalId : name;
}

export function getDescriptionType(productType: ProductType) {
  switch (productType) {
    case ProductTypeEnum.FACULTY:
      return ReferenceType.FACULTY_DESCRIPTION;
    case ProductTypeEnum.QUALIFICATION:
      return ReferenceType.QUALIFICATION_DESCRIPTION;
    case ProductTypeEnum.SPECIFICATION:
      return ReferenceType.SPECIFICATION_DESCRIPTION;
    case ProductTypeEnum.STUDY:
      return ReferenceType.STUDY_DESCRIPTION;
    case ProductTypeEnum.GROUP:
      return ReferenceType.MODULEGROUP_DESCRIPTION;
    case ProductTypeEnum.MODULE:
      return ReferenceType.MODULE_DESCRIPTION;
    default:
      throw new Error("Unknown entity type");
  }
}
